module.exports = __webpack_public_path__ + "static/media/masonry_1.1161bbee.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/textures/masonry_1.jpg
// module id = 1130
// module chunks = 0